export default (cpfWithMask) => {
  let count;
  let remaining;
  count = 0;
  if (!cpfWithMask) {
    return true;
  }

  const cpf = cpfWithMask.match(/\d+/g).join('');

  if (
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  )
    return false;

  for (let i = 1; i <= 9; i += 1) count += +cpf.substring(i - 1, i) * (11 - i);
  remaining = (count * 10) % 11;

  if (remaining === 10 || remaining === 11) remaining = 0;
  if (remaining !== +cpf.substring(9, 10)) return false;

  count = 0;
  for (let i = 1; i <= 10; i += 1) count += +cpf.substring(i - 1, i) * (12 - i);
  remaining = (count * 10) % 11;

  if (remaining === 10 || remaining === 11) remaining = 0;
  if (remaining !== +cpf.substring(10, 11)) return false;

  if (cpf.length < 11) {
    return false;
  }
  return true;
};
